import {IUOMPolicy} from "./PA.MD.Services.IF";
import * as _ from "lodash"
import {PlanTypeUOMPolicy} from "./PlanTypeUOMPolicy";



export class   UOMPolicyService
{
    private static dctPolicy: {[policyId:string]: IUOMPolicy} = _.keyBy([new PlanTypeUOMPolicy(false), new PlanTypeUOMPolicy(true)],
        (a) => a.PolicyId)


    static getUOMPolicy(policyId: string): IUOMPolicy
    { return UOMPolicyService.dctPolicy[policyId]  }

}

